module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-11.2ae6dd31.png";